import {ChangeDetectionStrategy, Component, Inject, Input, OnChanges, OnInit, SimpleChanges} from "@angular/core";
import {ServiceType} from "../../../types/service.type";

@Component({
  standalone: false,
  selector: 'app-service-link',
  templateUrl: './service-link.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ServiceLinkComponent implements OnInit, OnChanges {
  @Input() id: string;
  @Input() externalId?: string;
  @Input() serviceType: string;
  @Input() isAllowCopyButton?: boolean;


  public displayId: string;
  public isShowCopyBtn: boolean = false;
  public displayExternal: boolean;
  public serviceTypes: typeof ServiceType = ServiceType;

  constructor(@Inject('splitService') private splitService) {
    this.displayExternal = splitService.getSiteExternalIdConfig();
  }

  ngOnInit(): void {
    this.initDisplayId();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.id && !changes.id.isFirstChange() ||
      changes.id && !changes.id.isFirstChange()) {
      this.initDisplayId();
    }
  }

  private initDisplayId() {
    this.displayId = !this.externalId ?
      this.id :
      (this.displayExternal ? this.externalId : this.id);
  }

}
